export class InputPersonalAgreementUiText {
    static readonly AGREEMENT_TEXT = 'common.components.inputPersonalAgreement.agreementText';
    static readonly EXPLICIT_AGREEMENT_DECLINE_LABEL = 'common.components.inputPersonalAgreement.explicitAgreement.decline.label';
    static readonly EXPLICIT_AGREEMENT_CONSENT_LABEL = 'common.components.inputPersonalAgreement.explicitAgreement.consent.label';
    static readonly IMPLICIT_AGREEMENT_LABEL = 'common.components.inputPersonalAgreement.implicitAgreement.label';
    static readonly TYPE_EXPLICIT_REQUIRED_VALIDATION = 'common.components.inputPersonalAgreement.typeExplicit.required';
    static readonly TYPE_IMPLICIT_REQUIRED_VALIDATION = 'common.components.inputPersonalAgreement.typeImplicit.required';
}


